;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('FilterUsersDropdownController', filterUsersDropdownController)

  /* @ngInject */
  function filterUsersDropdownController ($scope, $attrs, $timeout, AdminService, ToastService) {
    const defaultUsersList = Array.from($scope.defaultUsersList)

    $scope.usersList = defaultUsersList
    $scope.usersSelected = []
    $scope.usersSelectedCache = []

    $scope.userInput = {
      search: ''
    }

    $scope.flags = {
      hasShowMoreButton: false,
      loadingShowMore: false,
      noResults: false,
      loading: false,
      skip: null,
      top: 4
    }

    const api = {
      _loadDataUsers,
      _successGetDataUsers,
      _errorGetDataUsers,
      _hasMoreResults,
      _initObserverShowMore,
      _verifyIntersectionButton,
      _getShowMore,
      _handleToggleDropdown,
      _mergeUsersList,
      _checkUserAlreadyExistsInArray,
      _checkEqualUserId,
      _onShowDropdown,
      _onHideDropdown
    }
    this.getApi = () => api

    activate()

    function activate () {
      const dropdownParams = {
        action: 'nothing',
        direction: 'downward',
        fullTextSearch: true,
        onShow: api._onShowDropdown,
        onHide: api._onHideDropdown
      }

      api._handleToggleDropdown(dropdownParams)
    }

    $scope.$on('filters.updateUserFilters', () => {
      $scope.flags.skip = 0
      api._loadDataUsers($scope.userInput, false)
    })

    $scope.$watch('params.users', (newValue) => {
      $scope.usersSelected = [...newValue]
      if (newValue.length && !$scope.userInput.search) {
        api._mergeUsersList($scope.usersSelected, $scope.usersList)
      } else {
        $scope.usersList = defaultUsersList
      }
    })

    $scope.handleSelect = (user) => {
      const index = $scope.usersSelected.findIndex(userSelected => api._checkEqualUserId(userSelected, user))
      if (index !== -1) {
        $scope.usersSelected.splice(index, 1)
      } else {
        $scope.usersSelected = [user, ...$scope.usersSelected]
      }
    }

    $scope.isSelected = (user) => {
      const hasUserSelected = $scope.usersSelected.find(userSelected => api._checkEqualUserId(userSelected, user))

      if (hasUserSelected) {
        return true
      }

      return false
    }

    $scope.handleRemove = (removeJustSelected) => {
      if (removeJustSelected) {
        $scope.usersSelectedCache = [...$scope.usersSelected]
        $scope.usersSelected = []
        return
      }

      $scope.params.users = []
      api._handleToggleDropdown('hide')
    }

    $scope.handleApply = () => {
      if ($scope.usersSelected.length) {
        $scope.params.users = $scope.usersSelected
      } else {
        $scope.params.users = []
      }

      api._handleToggleDropdown('hide')
      $scope.usersList = defaultUsersList
      $scope.userInput.search = ''
      $scope.flags.skip = null
    }

    $scope.userSearchInput = () => {
      $scope.flags.loading = true
      $scope.flags.skip = null
      api._loadDataUsers($scope.userInput)
    }

    $scope.scrollShowMore = api._getShowMore

    /**
     *  This method gets all users, but gets only when the role is user
     *  @param {object} search - Object with search input
     *  @param {boolean} loadMore - if true, load more users
     *  @description - Load users from API
     */
    function _loadDataUsers ({ search }, loadMore) {
      AdminService.filterUsers($scope.flags.top, $scope.flags.skip, { search }).then(response => {
        api._successGetDataUsers(response, loadMore)
      }).catch(api._errorGetDataUsers)
    }

    /**
     *  @param {object} response - response from server
     *  @param {boolean} loadMore - if true, merge usersList with response.data
     *  @description - Success callback for getUsers
     */
    function _successGetDataUsers (response, loadMore) {
      $scope.flags.noResults = false

      const { rows, count } = response

      if (loadMore) {
        api._mergeUsersList($scope.usersList, rows)
      } else {
        $scope.usersList = rows
      }

      $timeout(api._initObserverShowMore, 500, false)

      $scope.flags.hasShowMoreButton = api._hasMoreResults(count, $scope.usersList.length)

      if (!$scope.usersList.length) {
        $scope.flags.loading = false
        $scope.flags.noResults = true
        return
      }

      $scope.flags.loadingShowMore = false
      $scope.flags.loading = false
    }

    /**
     *  @description - Error callback for getUsers
     */
    function _errorGetDataUsers () {
      ToastService.defaultErrorToast()
      $scope.flags.loading = false
      $scope.flags.loadingShowMore = false
      $scope.flags.noResults = true
    }

    /**
     *  @param {Number} totalCount - total count of users
     *  @param {Number} responseLength - total count of array of users in response
     */
    function _hasMoreResults (totalCount, responseLength) {
      if (!responseLength) {
        return false
      }

      return totalCount > responseLength
    }

    /**
     *  @description Create the intersection observer by calling its constructor and passing
     *  it a callback function to be run whenever a threshold is crossed in one direction
     *  or the other
     */
    function _initObserverShowMore () {
      const showMoreButton = $attrs.$$element.find('.button-load-more')

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.4
      }

      const observer = new IntersectionObserver(api._verifyIntersectionButton, options)

      if (showMoreButton[0]) {
        observer.observe(showMoreButton[0])
      }
    }

    /**
     *  @param {object} entry - one entry for each target which reported a change in its intersection status.
     *  @description this method verify if button is show, if is show, call method to load more users
     */
    function _verifyIntersectionButton ([entry]) {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.4 && entry.intersectionRatio < 1 && $scope.flags.hasShowMoreButton) {
        $timeout(api._getShowMore, 0, true)
      }
    }

    /**
     *  @description this method get the next page of users
     */
    function _getShowMore () {
      $scope.flags.loadingShowMore = true
      $scope.flags.skip = $scope.flags.top + $scope.flags.skip
      api._loadDataUsers($scope.userInput, true)
    }

    /**
     *  @param {object | string} options - config options for semantic dropdown
     *  @description this method open/close the dropdown menu, or initialize it
     */
    function _handleToggleDropdown (options) {
      $timeout(() => {
        $attrs.$$element.find('.ui.dropdown.filter-users-dropdown').dropdown(options)
      }, 100, false)
    }

    /**
     *  @typedef {Array} ArrayList
     *  @param {ArrayList} firstArray - items that will be first in the new array of users
     *  @param {ArrayList} lastArray - items that will be last in the new array of users
     *  @description this method merge two arrays and create a new array, only serve to merge the array of users
     */
    function _mergeUsersList (firstArray, lastArray) {
      const updatedList = lastArray.map(api._checkUserAlreadyExistsInArray).filter(Boolean)
      $scope.usersList = [...firstArray, ...updatedList]
    }

    /**
     *  @param {object} user - object of user
     *  @description this method check if the user already exists in the array of users
     */
    function _checkUserAlreadyExistsInArray (user) {
      const index = $scope.usersSelected.findIndex(selectedUser => api._checkEqualUserId(selectedUser, user))
      if (index === -1) {
        return user
      }
    }

    /**
     *  @param {object} selectedUser - object of user
     *  @param {object} user - object of selectedUser
     *  @description this method checks if the selectedUser is equal to the user
     */
    function _checkEqualUserId (selectedUser, user) {
      return selectedUser.id === user.id
    }

    /**
     *  @description this method is called on show the semantic dropdown
     */
    function _onShowDropdown () {
      $timeout(api._initObserverShowMore, 500, false)

      $timeout(() => {
        $scope.flags.hasShowMoreButton = api._hasMoreResults($scope.countUsers, $scope.usersList.length)
      }, 0, true)
    }

    /**
     *  @description this method is called on hide the semantic dropdown
     */
    function _onHideDropdown () {
      if (!$scope.usersSelected.length && $scope.usersSelectedCache.length) {
        $scope.usersSelected = [...$scope.usersSelectedCache]
      }
    }
  }
})()
